import * as actionType from './actionTypes';
import { toastr } from "react-redux-toastr";
import axios  from 'axios';

import * as studentSideActions from './studentSideAction';
import * as tutorSideActions from './freeTestAction';

import { default as apiEndPoints } from "../../Routes/Login/utils/apiEndPoints";
import config, { internalWebView } from "../../Api";
import store from '../store';
import {parseQueryString} from '../../util';

const QUERY = parseQueryString(window.location.search);
const TestId=QUERY.testId;

export const getFreeTestAction = () => (dispatch, getState) => {
     axios
        .get(
            `${config.API_URL_TUTOR}${apiEndPoints.LOGIN.GET_ORG.url(
                TestId
            )}`
        )
        .then(response => { 
            if(response.data.data && response.data.data.organization && response.data.data.organization.code){
            axios.get(`${config.WL_URL}${apiEndPoints.LOGIN.ORG_NAME.url(
                response.data.data.organization.code
            )}`
            )
            .then(res => {
                 dispatch({
                    type:actionType.SET_ORG_NAME,
                    payload:{
                        data:res.data.data
                    }
                })
    
            })
            .catch(err => {
                toastr.error("ERROR", "Something went wrong");
            });

            axios.get(`${config.WL_URL}${apiEndPoints.LOGIN.GET_COUNTRY_DETAILS.url(
                    response.data.data.organization.id
                )}`)
                .then((CountyResp)=>{
                    console.log("res",CountyResp)
                    dispatch({
                        type:actionType.SET_COUNTRY_DETAILS,
                        payload:{
                            data:CountyResp.data.data
                        }
                    })
                }).catch(err=>{
                    console.log(err)
                    toastr.error("ERROR", err.response.data.message);
                })
        }
            dispatch({
                type:actionType.SET_ORG,
                payload:{
                    data:response.data.data
                }
            })

        })
        .catch(err => {
            toastr.error("ERROR", "Something went wrong");
        });
};

export const setMobileAction = payload => {
    return {
        type: actionType.SET_MOBILE,
        payload
    };
};

export const setEmailAction = payload => ({
    type: actionType.SET_EMAIL,
    payload
});

export const setStatusAction = payload => {  
    return {
        type: actionType.SCREEN_REDIRECTION_STATUS,
        payload
    }
};

export const verifyOtpErrorChangeAction = payload => {
    return { type: actionType.VERIFY_OTP_ERROR_CHANGE, payload };
};

export const generateOtpAction = (payload) => (dispatch, getState) => {
    const dateObj = new Date();
    let hashNumber = dateObj.getTime();
     axios
        .post(
            `${config.WL_URL}${apiEndPoints.LOGIN.GENERATE_OTP.url(
                payload.retry
            )}`,
            payload,
            {
                headers: {
                    "Api-Version": 18,
                    "device-id" : hashNumber
                }
            }
        )
        .then(response => {
            toastr.success("SUCCESSFULLY", "OTP Sent Successfully");
            dispatch({
                type:actionType.GENERATE_OTP_SUCCESS,
                payload:{
                    generateOtp:response.data.data
                }
            })

        })
        .catch(err => {
            toastr.error("ERROR", "Something went wrong");
        });
};

export const setOtpAction = payload => {
    return { type: actionType.SET_OTP, payload };
};

export const verifyOtpAction = payload => (dispatch, getState) =>{
    axios.post(
        `${config.WL_URL}${apiEndPoints.LOGIN.VERIFY_OTP.url()}`,
        payload,
        {
            headers: {
                "Api-Version": 18
            }
        }
    )
    .then(response => {
        if (response && (response.status == 200 || response.status == 201)) {
            if(response.data.data && response.data.data.user.type==2)
            {
                toastr.warning("Error", "You are registered as parent, only students can attempt test"); 
            }
            else if(response.data.data && response.data.data.user.type==3)
            {
                toastr.warning("Error", "You are registered as Tutor, only students can attempt test"); 
            }
            else{ toastr.success("SUCCESSFULLY", "OTP Verified Successfully");
                let verifyOtpData= response.data.data;
                if (!verifyOtpData.user.exists || (verifyOtpData.user.exists && verifyOtpData.user.signedUp == 0)) {
                    dispatch({
                        type: actionType.SCREEN_REDIRECTION_STATUS,
                        payload: "Register"
                    })
                }
                else{
                    dispatch({
                        type:actionType.VERIFY_OTP_SUCCESS,
                        payload:{
                            verifyOtp:response.data.data,
                            verifyOtpError: false,
                        }
                    });
                }
            }
        }
           
    })
    .catch(err => {
        toastr.error("ERROR", err.response.data.message);
        dispatch({
            type:actionType.VERIFY_OTP_FAILURE,
            payload:{
                verifyOtp:err.response.data.message,
                verifyOtpError: true,
            }
        })
    });
};

export const registerUserAction = payload => (dispatch,getState)=>{
    axios
        .post(
            `${config.WL_URL}${apiEndPoints.LOGIN.REGISTER_USER.url()}`,
            payload,
            {
                headers: {
                    "Api-Version": 18
                }
            }
        )
        .then(response => {
            if (response && (response.status == 200 || response.status == 201)) {
                toastr.success("SUCCESSFULLY", "Registered Successfully");
                dispatch({
                 type: actionType.REGISTER_USER_SUCCESS,
                    payload:{
                        registerUserError: false,
                        registerUser: response.data.data
                    }
                });
            }
        })
        .catch(err => {
            toastr.error("ERROR", "Something went wrong");
        dispatch({
            type: actionType.REGISTER_USER_FAILURE,
            payload:{
                registerUserError: true,
                registerUser: err.response.data.message
            }    
        });
     });
}


export const attemptTestApi= ()=>(dispatch,getState)=>{
    let state = store.getState();
    const urlParams = new URLSearchParams(window.location.search);
     
    let testId = state.loginReducer.testId || urlParams.get('testId');
    let WL_Token = localStorage.getItem("data") && JSON.parse(localStorage.getItem("data")).token
    axios.get(`${config.WL_URL}${apiEndPoints.LOGIN.GET_CMS_TOKEN.url(testId)}`,{
        headers:{
            "x-access-token":WL_Token
        }
    }).then((response)=>{
        let token=response.data.data.token;
        axios.get(`${config.API_URL_STUDENT}${apiEndPoints.LOGIN.APPEAR_TEST.url(testId)}`,{
            headers:{
                "x-cms-access-token": token
            }
        })
        .then(res => {
             dispatch({
                type: actionType.SET_TEST_URL,
                payload:{
                    data: res.data.data,
                    isTestStarted:0,
                } 
             })
        }).catch(err=>{
            toastr.error("ERROR", err.response.data.message);
            if(err && err.response.status!==404)
            {
            dispatch({
                type: actionType.SET_TEST_URL_FAIL,
                payload:{
                    data: err.response.data.data,
                    isTestStarted:err.response.data.data.testStatus
                } 
             })
            }    
        })
    }).catch(err=>{
        if(err && err.response.status!==401){
            toastr.error("Error",err.response.data.message)
        }
        else{
            let WL_Refresh_Token = localStorage.getItem("data") && JSON.parse(localStorage.getItem("data")).refreshToken
            axios.post(`${config.WL_URL}${apiEndPoints.LOGIN.WL_REFRESH_ACCESS_TOKEN.url()}`,{

                refreshToken: WL_Refresh_Token
            },
            {
                headers: {
                    "Api-Version": 18
                }
            }).then(response=>{
                let localData = JSON.parse(localStorage.getItem("data")) ;
                    localData = {
                        ...localData,
                        token: response.data.data.token,
                        tokenExpiryTime:response.data.data.tokenExpiryTime
                    };
                    window.localStorage.setItem("data", JSON.stringify(localData));
                    window.location.href=window.location.href.replace("/attempt","")
            })
            .catch((error)=>{
                window.localStorage.clear();
                window.location.href=window.location.href.replace("/attempt","")
            })
            
        }
    })  
}

export const fetchStudentSideToken = (payload) => (dispatch,getState) => {
    axios({
        method: "GET",
        url: `${config.WL_URL}${apiEndPoints.LOGIN.GET_STUDENT_SIDE_TOKEN.url()}`,
        headers: {
          "x-access-token": payload.token
        },
      })
        .then((response) => {
            dispatch({
                type: actionType.SET_STUDENT_SIDE_TOKEN,
                payload: {
                    wlToken: payload.token,
                    studentSideToken: response.data.data.token
                }
            })
            if(payload.isStudent) {
                dispatch(studentSideActions.fetchFreeTest({
                    limit: 10,
                    offset: 0
                }))
                dispatch(studentSideActions.fetchAttemptedTest({
                    limit: 10,
                    offset: 0
                }))
                dispatch(studentSideActions.fetchFreeTest({
                    limit: 10,
                    offset: 0,
                    isUpcoming:true
                }))
            }
        })
        .catch((err) => {
            toastr.error("ERROR", "Something went wrong");
        });
}

export const fetchTutorSideToken = (payload,history) => (dispatch,getState) => {
    axios({
        method: "GET",
        url: `${config.API_URL_TUTOR}${apiEndPoints.LOGIN.GET_TUTOR_SIDE_TOKEN.url(payload)}`,
        headers: {
          "x-wl-access-token": payload.token
        },
      })
        .then((response) => {
            dispatch({
                type: actionType.SET_TUTOR_SIDE_TOKEN,
                payload: {
                    wlToken: payload.token,
                    tutorSideToken: response.data.data.token
                }
            })
            dispatch(tutorSideActions.getFreeTestList({
                limit: 10,
                offset: 0
            }))
        })
        .catch((err) => { console.log(err)
            if(err && err.response.status==404){
                history.replace(`/notFound?&token=${payload.token}`)
            }
           

             else{
                toastr.error("ERROR", err.response.data.message);
             }
        });
}

export const studentSideAttempt = (payload)=>(dispatch,getState)=>{
    let state = store.getState();
        axios.get(`${config.API_URL_STUDENT}${apiEndPoints.LOGIN.APPEAR_TEST.url(payload.testId)}/?reAttempt=${payload.isAttempted}`,{
            headers:{
                "x-cms-access-token": state.loginReducer.studentSideToken?state.loginReducer.studentSideToken:payload.token
            }
        })
        .then(response => {
             dispatch({
                type: actionType.SET_TEST_URL,
                payload:{
                    data: response.data.data,
                    isTestStarted:0,
                    isStudent: true
                } 
             })
             let testUrl = response.data.data && response.data.data.URL+`&testId=${response.data.data.testId}`;
             internalWebView({
                 url: `${testUrl}`,
                 isUrl: true
             });
        }).catch(err=>{
            toastr.error("ERROR", err.response.data.message);
            if(err && err.response.status!==404)
            {
            dispatch({
                type: actionType.SET_TEST_URL,
                payload:{
                    data: err.response.data.data,
                    isTestStarted:err.response.data.data.testStatus,
                    isStudent: true
                } 
             })  
            }  
        })
}